import { render, staticRenderFns } from "./OutboundBlockedListBox.vue?vue&type=template&id=37657ee5&scoped=true"
import script from "./OutboundBlockedListBox.vue?vue&type=script&lang=js"
export * from "./OutboundBlockedListBox.vue?vue&type=script&lang=js"
import style0 from "./OutboundBlockedListBox.vue?vue&type=style&index=0&id=37657ee5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37657ee5",
  null
  
)

export default component.exports